import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [{
		path: '/',
		name: 'usercenter',
		component: () => import('@/views/common/layout.vue'),
		redirect: '/index/index',
		meta: {
			only: true,
			visible: true,
		},
		children: [{
			path: '/index/index',
			name: 'index',
			component: () => import('@/views/index/index.vue'),
			meta: {
				title: '概况中心',
				visible: true,
				icon: "center-icon",
			}
		},
		{
			path: '/aivideo/aivideo',
			name: 'index',
			component: () => import('@/views/aivideo/aivideo.vue'),
			meta: {
				title: 'AI生成视频',
				visible: true,
				icon: "center-icon",
			}
		}
		]
	}, {
		path: '/',
		name: 'user',
		meta: {
			title: '个人中心',
			// icon: 'el-icon-goods',
			icon: "user-icon",
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/user/info',
			name: 'info',
			component: () => import('@/views/user/info.vue'),
			meta: {
				title: '个人信息',
				visible: true,
			},
		}, {
			path: '/user/message',
			name: 'message',
			component: () => import('@/views/user/message.vue'),
			meta: {
				title: '消息列表',
				visible: true,
			},
		}, {
			path: '/user/list',
			name: 'userlist',
			component: () => import('@/views/user/list.vue'),
			meta: {
				title: '角色人员列表',
				visible: true,
			},
		},{
			path: '/user/userList',
			name: 'userlist',
			component: () => import('@/views/user/userList.vue'),
			meta: {
				title: '用户列表',
				visible: true,
			},
		}]
	}, {
		path: '/',
		name: 'announcement',
		meta: {
			title: '公告管理',
			// icon: 'el-icon-goods',
			icon: "user-icon",
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/announcement/announcementList',
			name: 'footCate',
			component: () => import('@/views/announcement/announcementList.vue'),
			meta: {
				title: '公告列表',
				visible: true,
			},
		}]
	},{
		path: '/',
		name: 'system',
		meta: {
			title: '系统管理',
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/system/admin',
			name: 'admin',
			component: () => import('@/views/system/admin.vue'),
			meta: {
				title: '管理员管理',
				visible: true,
			},
		}, {
			path: '/system/role',
			name: 'role',
			component: () => import('@/views/system/role.vue'),
			meta: {
				title: '角色管理',
				visible: true,
			},
		}, {
			path: '/system/menu',
			name: 'menu',
			component: () => import('@/views/system/menu.vue'),
			meta: {
				title: '菜单管理',
				visible: true,
			},
		}, {
			path: '/system/option',
			name: 'option',
			component: () => import('@/views/system/option.vue'),
			meta: {
				title: '操作权限管理',
				visible: true,
			},
		}, {
			path: '/system/viprule',
			name: 'business',
			component: () => import('@/views/system/viprule.vue'),
			meta: {
				title: '会员等级管理',
				visible: true
			},
		}, {
			path: '/system/paramsimple',
			name: 'paramsimple',
			component: () => import('@/views/system/params.vue'),
			meta: {
				title: '参数管理',
				visible: true
			},
		}, {
			path: '/system/log',
			name: 'log',
			component: () => import('@/views/system/log.vue'),
			meta: {
				title: '操作日志',
				visible: true
			},
		}]
	}, {
		path: '/',
		name: 'order',
		meta: {
			title: '订单管理',
			// icon: 'el-icon-goods',
			icon: "user-icon",
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/order/orderdeal',
			name: 'orderdeal',
			component: () => import('@/views/order/orderdeal.vue'),
			meta: {
				title: '待完成列表',
				visible: true,
			},
		}, {
			path: '/order/orderlist',
			name: 'orderlist',
			component: () => import('@/views/order/orderlist.vue'),
			meta: {
				title: '订单列表',
				visible: true,
			},
		}, {
			path: '/order/ordersum',
			name: 'orderlist',
			component: () => import('@/views/order/ordersum.vue'),
			meta: {
				title: '订单汇总',
				visible: true,
			},
		},  {
			path: '/order/orderitems',
			name: 'orderlist',
			component: () => import('@/views/order/orderitems.vue'),
			meta: {
				title: '订单汇总',
				visible: true,
			},
		}, {
			path: '/order/userorder',
			name: 'userorder',
			component: () => import('@/views/order/userorder.vue'),
			meta: {
				title: '点单详情',
				visible: false,
			},
		}]
	}, {
		path: '/',
		name: 'banner',
		meta: {
			title: '首页管理管理',
			// icon: 'el-icon-goods',
			icon: "user-icon",
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/banner/actbanner',
			name: 'actbanner',
			component: () => import('@/views/banner/actbanner.vue'),
			meta: {
				title: '首页banner',
				visible: true,
			},
		},{
			path: '/topnav/list',
			name: 'topnav',
			component: () => import('@/views/topnav/list.vue'),
			meta: {
				title: '首页导航',
				visible: true,
			},
		}]
	}, {
		path: '/',
		name: 'staff',
		meta: {
			title: '员工管理',
			// icon: 'el-icon-goods',
			icon: "user-icon",
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/staff/staffList',
			name: 'staffList',
			component: () => import('@/views/staff/staffList.vue'),
			meta: {
				title: '员工列表',
				visible: true,
			},
		}]
	},  {
		path: '/',
		name: 'notice',
		meta: {
			title: '消息通知管理',
			icon: "user-icon",
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/notice/noticeList',
			name: 'noticeList',
			component: () => import('@/views/notice/noticeList.vue'),
			meta: {
				title: '消息通知列表',
				visible: true,
			},
		}]
	}, {
		path: '/',
		name: 'project',
		meta: {
			title: '维修项目管理',
			// icon: 'el-icon-goods',
			icon: "user-icon",
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/project/projectList',
			name: 'project',
			component: () => import('@/views/project/projectList.vue'),
			meta: {
				title: '维修项目',
				visible: true,
			},
		}]
	}, {
		path: '/',
		name: 'news',
		meta: {
			title: '系统设置',
			// icon: 'el-icon-goods',
			icon: "user-icon",
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/setting/work',
			name: 'company',
			component: () => import('@/views/setting/work.vue'),
			meta: {
				title: '排班调度',
				visible: true
			},
		}]
	}, {
		path: '/',
		name: 'news',
		meta: {
			title: '新闻公告',
			// icon: 'el-icon-goods',
			icon: "user-icon",
			visible: true,
		},
		component: () => import('@/views/common/layout.vue'),
		children: [{
			path: '/webnews/newslist',
			name: 'company',
			component: () => import('@/views/webnews/newslist.vue'),
			meta: {
				title: '新闻管理',
				visible: true
			},
		}, {
			path: '/webnews/noticelist',
			name: 'company',
			component: () => import('@/views/webnews/noticelist.vue'),
			meta: {
				title: '公告管理',
				visible: true
			},
		}]
	},
		{
			path: '/',
			name: 'common',
			meta: {
				// only: true,
				// icon: 'el-icon-goods',
				visible: false,
			},
			component: () => import('@/views/common/layout.vue'),
			children: [{
				path: '/error',
				name: 'error',
				meta: {
					title: '错误页面',
					visible: false,
				},
				component: () => import('@/views/error/index')
			}],
		},
		{
			path: '/login',
			name: 'login',
			meta: {
				title: '登录',
			},
			component: () => import('@/views/account/login')
		},{
			path: '/',
			name: 'join',
			meta: {
				title: '商家管理',
				// icon: 'el-icon-goods',
				icon: "user-icon",
				visible: true,
			},
			component: () => import('@/views/common/layout.vue'),
			children: [{
				path: '/join/business',
				name: 'joinbusiness',
				component: () => import('@/views/join/business.vue'),
				meta: {
					title: '商家店铺管理',
					visible: true
				},
			}, {
				path: '/join/goodsgroup',
				name: 'joingoodsgroup',
				component: () => import('@/views/join/goodsgroup.vue'),
				meta: {
					title: '商家商品分类管理',
					visible: true
				},
			}, {
				path: '/join/goods',
				name: 'joingoods',
				component: () => import('@/views/join/goods.vue'),
				meta: {
					title: '商家商品管理',
					visible: true
				},
			}, {
				path: '/join/channel',
				name: 'joinchannel',
				component: () => import('@/views/join/channel.vue'),
				meta: {
					title: '商家频道管理',
					visible: true
				},
			}, {
				path: '/join/channelgoods',
				name: 'joinchannelgoods',
				component: () => import('@/views/join/channelgoods.vue'),
				meta: {
					title: '商家频道商品管理',
					visible: true
				},
			}, {
				path: '/join/users',
				name: 'joinusers',
				component: () => import('@/views/join/users.vue'),
				meta: {
					title: '商家用户管理',
					visible: true
				},
			}]
		},{
			path: '/',
			name: 'joinorder',
			meta: {
				title: '商家订单管理',
				icon: "user-icon",
				visible: true,
			},
			component: () => import('@/views/common/layout.vue'),
			children: [{
				path: '/join/orderdeal',
				name: 'joinorderdeal',
				component: () => import('@/views/join/orderdeal.vue'),
				meta: {
					title: '待完成订单',
					visible: true
				},
			}, {
				path: '/join/orderlist',
				name: 'joinorderlist',
				component: () => import('@/views/join/orderlist.vue'),
				meta: {
					title: '已完成订单',
					visible: true
				},
			}]
		}
	]
})
